import React from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { getContext } from '@fiverr-private/fiverr_context';
import { BriefStatusTag } from '@fiverr-private/dynamic_matching';
import { BriefItem } from '../../../../../lib/types/brief';
import { getCreatedByUserName } from '../../../../../lib/utils/getters';
import { formatTimestamp } from '../../../../../lib/utils/time';
import { Action } from '../Action';
import { BriefTitle } from '../Title/BriefTitle';
import { More } from '../More';

interface MobileProps {
  row: Row<BriefItem>;
  openSuccessModal: () => void;
}

export const Mobile: React.FC<MobileProps> = ({ row, openSuccessModal }: MobileProps) => {
  const { organizationId } = getContext();

  return (
    <Stack direction="column" gap="8">
      <Stack direction="column" gap="2">
        <Stack direction="row" alignItems="center" justifyContent="spaceBetween">
          <BriefTitle row={row} />
          <More row={row} openSuccessModal={openSuccessModal} />
        </Stack>

        <Stack direction="column" gap="1">
          <Typography as="p" color="grey_900" size="b_sm">
            {formatTimestamp(row.original.createdAt)}
          </Typography>
          {!!organizationId && (
            <Typography as="p" size="b_sm" color="grey_900">
              {getCreatedByUserName(row.original.createdBy)}
            </Typography>
          )}
        </Stack>
        <BriefStatusTag status={row.original.briefDisplayStatus} />
      </Stack>

      <Action row={row} />
    </Stack>
  );
};
